export default "__VITE_ASSET__XPOjocSX__"